export const ALLOWED_ROLES = ["agent", "menadzer", "rukovodilac"];

export const INCOMPLETE_FILTERS = [
  { value: "deleted", name: "Obrisane" },
  { value: "sold", name: "Prodate" },
  { value: "published", name: "Neodobrene" },
  { value: "descriptionPublished", name: "Neodobren Opis" },
  { value: "propertyId", name: "Bez Šifre" },
  { value: "pictures", name: "Slike" },
];
